<script>
  import { onMount, onDestroy } from "svelte";
  export let task;
  export let userId;

  let refResults;
  let results;

  let resultsReversed = [];
  $: resultsReversed = results ? JSON.parse(JSON.stringify(results)).reverse() : [];

  onMount(() => {
    results = [];
    refResults = firebase.database()
      .ref("edulearn/tasks/checkbyuserbytask/").child(userId).child(task.id);;
    refResults.off();
    refResults.on('child_added', snap => {
      let result = snap.val();
      // console.log(snap.key);
      result["id"] = snap.key;
      if (!results.find(t => t.id == snap.key)) {
        results = [...results, result];
      }
    });      
  });

  onDestroy(() => {
    refResults && refResults.off();
  });

</script>

<style>
  ul {
    list-style-type: none;
  }

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    /* transition: 0.8s; */
    transition: all 0.3s;
    /* display: inline-block; */
    vertical-align: top;
    margin: 10px;
    max-width: 700px;
    padding: 15px;
    border-radius: 10px;
    /* position: relative; */
    background-color: rgb(174, 193, 211);
  }

  .card.solved {
      background-color: rgb(174, 211, 176);      
  }

  pre.code {
    cursor: text;
    font-size: 16px;
    font-family: Courier New, monospace;
    background-color: #393030;
    color: #ffffd0;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    border-style: 1px dashed;
    padding: 10px 10px 10px 10px;
    position: relative;
    outline: none;
    tab-size: 4;
    -o-tab-size: 4;
    -moz-tab-size: 4;
  }
</style>

{#if results && results.length > 0}
  <!-- <h1>Попыток: {results.length} {results[0].user_email} ({results[0].user_name})</h1> -->
  <h1>Попыток: {results.length}</h1>
  <ul>
    {#each resultsReversed as result, i (result.id)}
      <li class="card" class:solved="{result.ok}">
        <h2>{resultsReversed.length - i}. {result.ok}</h2>
        {new Date(result.timestamp)}
        <pre class="code">{result.code}</pre>
        <h3>compileOutput</h3>
        <pre>{result.compileOutput}</pre>
        <h3>failureMessages</h3>
        <pre>{result.failureMessages}</pre>
        <small>Server: {result.runTime} ms.</small>
      </li>
    {/each}
  </ul>
{/if}